module.exports = __webpack_public_path__ + "static/media/full-screen.fc113484.svg";